import { Popover, type PopoverProps } from "@mui/material";
import type { ChangeEvent, FC } from "react";
import styles from "./styles.module.css";

interface Props extends PopoverProps {
	areaValue: string
	handleChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const ComparisonChatInstruction: FC<Props> = ({ areaValue, handleChange, ...props }) => {
  return (
    <Popover
      classes={{
        paper: styles.popover
      }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }} {...props}>
      <div className={styles.wrapper}>
        <textarea value={areaValue} onChange={handleChange} placeholder={"Добавьте инструкцию"}
				          className={styles.instructions}/>
      </div>
    </Popover>
  );
};